<template>
	<div class="container">
		<div class="lianxi">
			<div class="lianxi-top">
        <div  class="fanhui" v-if="isShowBack">
          <img src="../../../static/images/other-fanhui.png" @click="back" >
        </div>
        <div  class="fanhui" v-if="!isShowBack">
        </div>
				<div class="tab">知识点细分练习</div>
			</div>
			<div class="zhishidian-mid">
				<div class="items" v-for="(item,index ) in list" :key="index" @click="toAnswer(item.chapter_id)">
					<div class="left">
						<div class="xuhao">{{index+1}}</div>
						<div class="des">{{item.chapter_name}}</div>
					</div>
					<div class="right">
						<div>{{item.question_num}}</div>
						<img src="../../../static/images/other-collectgo.png" />
					</div>
				</div>
			</div>
			<!-- <div class="zhuanxiang">
				<div class="timu">专项细分练习</div>
				<div class="info">
					<div class="items">
						<div class="left">
							<div class="xuhao">1</div>
							<div class="des">驾驶行为题</div>
						</div>
						<div class="right">87</div>
					</div>
					<div class="items">
						<div class="left">
							<div class="xuhao">1</div>
							<div class="des">驾驶行为题</div>
						</div>
						<div class="right">87</div>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
import { chapters } from "@/api/exam";
import { checkSign } from "@/api/verify";
export default {
	name: 'zjlx',
	components: {},
	data() {
		return {
			show: false,
			images: [require('../../assets/images/banner-1.jpg'), require('../../assets/images/banner-2.jpg')],
			swiperOption: {
				slidesPerView: 1,
				//显示分页
				pagination: {
					el: '.swiper-pagination'
				},
				loop: true
			},
			list:[],
      isShowBack: false
		};
	},
	created() {
    if (this.GetRequest('channel') == 'exejH5') {
      this.isShowBack = true
    }
	// 	let appver = this.GetRequest('appver') ? this.GetRequest('appver') : ''
    // let channel = this.GetRequest('channel') ? this.GetRequest('channel') : ''
    // let os = this.GetRequest('os') ? this.GetRequest('os') : ''
    // let sign = this.checkSing.checkMd5(this.GetRequest('appid')+appver+channel+this.GetRequest('cx')+this.GetRequest('km')+os+this.GetRequest('timestamp') + this.GetRequest('userid'))
    // if( this.GetRequest('appid') && this.GetRequest('cx') && this.GetRequest('km') && this.GetRequest('userid') && this.GetRequest('timestamp') && this.GetRequest('sign') && sign == this.GetRequest('sign')){

    // }else{
    //   this.$router.push({
    //     name: "error",
    //     params: { name: "item", id: 1 }
    //   });
    // }
	// checkSign({
  //       data_string : window.location.hash
  //   },({data})=>{
  //     console.log(11111111111111111)
  //     console.log(data)
  //     if(data.code != 0){
  //       this.$router.push({
  //         name: "error",
  //         params: { name: "item", id: 1 }
  //       });
  //     }
  //   })
		document.documentElement.style.fontSize = "625%"
		console.log(this.GetRequest('userid'))
		this.getChaptersList()
	},
	mounted(){
		document.documentElement.style.fontSize = "625%"
	},
	methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
		//获取知识点
		getChaptersList(){
			let data = {
				licence_id: this.GetRequest('cx')=='xc' ? 2 : this.GetRequest('cx')=='hc' ? 3 :this.GetRequest('cx')=='kc'? 4  :this.GetRequest('cx')=='mtc'?5:6,
				subject_id: this.GetRequest('km') == 'kmy'?1 : 4
			}
			chapters(data).then(({data}) => {
				console.log('===============================================================================');
				console.log('获取知识点',data)
				console.log('===============================================================================');
				this.list = data.list
			});
		},
		gotopage() {
			this.$router.push({ name: 'lianxidatidanxuan', params: { name: 'item', id: 1 } });
		},
		gototixingxuanzepage() {
			this.$router.push({ name: 'tixingxuanze', params: { name: 'item', id: 1 } });
		},

		GetRequest(value) {
			return this.$route.query[value];
		},
		toAnswer(id){
			this.$router.push({
				name: "lianxidatidanxuan",
				query: {
					userid: this.GetRequest('userid'),
					showType: this.GetRequest('km') == 'kmy'?1 : 4 ,
					chapterid : id,
					lid:this.GetRequest('cx')=='xc' ? 2 : this.GetRequest('cx')=='hc' ? 3 :this.GetRequest('cx')=='kc'? 4  :this.GetRequest('cx')=='mtc'?5:6,
					km:this.GetRequest('km'),
					cx:this.GetRequest('cx'),
					appid:this.GetRequest('appid'),
					appver:this.GetRequest('appver'),
					channel:this.GetRequest('channel'),
					os:this.GetRequest('os'),
					timestamp:this.GetRequest('timestamp'),
					sign:this.GetRequest('sign'),
					schoolid:this.GetRequest('schoolid')?this.GetRequest('schoolid') : '',
					coachid:this.GetRequest('coachid')?this.GetRequest('coachid') : ''
				}
			});
		},
	},
	afterDestory(){

		document.documentElement.style.fontSize = ""
	}
};
</script>

<style lang="scss" scoped>
html {
	background-color: #fff;
}
</style>
<style lang="scss">
.container {
	.lianxi {
		width: 100%;
		height: 3rem;
		margin: 0;
		padding: 0;
		.lianxi-top {
			background-size: 100% 100%;
			border-bottom: 1px solid #dcdcdc;
			padding-bottom: 0.11rem;
        .fanhui {
				position: absolute;
				top: 0.23rem;
				left: 0.23rem;
				width: 0.09rem;
				height: 0.18rem;
				img {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
			}
			.tab {
				margin-top: 0.22rem;
				color: #333;
				justify-content: center;
				width: 60%;
				margin-left: 20%;
				line-height: 0.18rem;
				text-align: center;
				font-size: 4.5vw;
			}
		}
		.zhishidian-mid {
			width: 92%;
			margin-left: 4%;
			.items {
				padding-top: 0.15rem;
				padding-bottom: 0.16rem;
				display: flex;
				justify-content: space-between;
				border-bottom: 1px solid #dcdcdc;
				.left {
					display: flex;
					align-items: center;
					width: 100%;
					.xuhao {
						width: 0.2rem;
						height: 0.2rem;
						background-color: #0195f7;
						font-size: 0.13rem;
						line-height: 0.2rem;
						text-align: center;
						color: #fff;
						border-radius: 50%;
					}
					.des {
						padding: 0;
						margin: 0;
						width: 85%;
						vertical-align: middle;
						font-size: 0.16rem;
						line-height: 0.2rem;
						color: #333;
						margin-left: 0.07rem;
					}
				}
				.right {
					display: flex;
					align-items: center;
					div {
						margin-right: 0.15rem;
						align-items: center;
						font-size: .12rem;
					}
					img {
						align-items: center;
						width: 0.07rem;
						height: 0.12rem;
					}
				}
			}
		}
		.zhuanxiang {
			width: 92%;
			margin-left: 4%;
			margin-top: 0.2rem;
			.timu {
				color: #333333;
				font-size: 0.19rem;
				font-weight: bold;
			}
			.info {
				display: flex;
				justify-content: space-between;
			}
			.items {
				width: 48%;
				border-bottom: 1px solid #dcdcdc;
				display: flex;
				justify-content: space-between;
				height: 0.55rem;
				.left {
					display: flex;
					align-items: center;
					.xuhao {
						width: 0.16rem;
						height: 0.16rem;
						background-color: #0195f7;
						font-size: 0.12rem;
						line-height: 0.16rem;
						text-align: center;
						color: #fff;
						border-radius: 50%;
					}
					.des {
						color: #333333;
						font-size: 0.15rem;
						margin-left: 0.06rem;
						font-weight: bold;
					}
				}
				.right {
					align-items: center;
					font-size: 0.12rem;
					display: flex;
					color: #999;
				}
			}
		}
	}
}
</style>
